import React, {Component} from 'react';
import exit from '../../assets/img/exit.svg'
import user from '../../assets/img/user.svg'
import favorite from '../../assets/img/favorite.svg'
import playlist from '../../assets/img/playlist.svg'
import logo from '../../assets/img/logo.svg'
import Util from "../../utils/utils"
import {Link} from "react-router-dom";
import {Button, Modal} from "react-bootstrap";

class Header extends Component {

    constructor(props) {
        super(props);


        this.state = {
            active_page: 0,
            showModal: false,
        };
    }

    handleShow = () => {
        this.setState({showModal: true});
    };

    handleClose = () => {
        this.setState({showModal: false});
    };

    setActivePage = (status) => {
        this.setState((oldState) => ({...oldState, active_page: status}))
    };

    logout = () => {
        Util.clearAll();
        window.location.href = "/login"
    };

    render() {
        const token = Util.getSession("token");

        if (!token)
            return (<></>);

        return (
            <>
                <Modal
                    backdrop="static"
                    keyboard={false}
                    dialogClassName="modal-dialog-centered m-auto"
                    show={this.state.showModal}
                    onHide={this.handleClose
                    }>
                    <Modal.Header className="flex-column">
                        <div className="icon-box">
                            <i className="fa fa-close" style={{
                                "color": "red",
                                "fontSize": "50px"
                            }}/>
                        </div>
                        <Modal.Title className="modal-title" style={{
                            "marginTop": "20px",
                            "direction": "rtl"
                        }}>خروج</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{"direction": "rtl"}}>
                            آیا میخواهید خارج شوید؟
                        </p>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button onClick={this.handleClose}>
                            خیر
                        </Button>
                        <Button onClick={this.logout}>
                            بله
                        </Button>
                    </Modal.Footer>
                </Modal>
                <header className="header">
                    <div>
                        <nav className="navbar navbar-expand-lg">
                            <a className="header-link row" href="#0" onClick={this.handleShow}>
                                <img className="header-link-img" src={exit} alt=""/>
                                خروج
                            </a>
                            <a className="header-link-phone order-0" href="#0" onClick={this.logout}>
                                <img className="header-link-img" src={exit} alt=""/>
                            </a>
                            <Link
                                to={{pathname: `/profile/`}}
                                onClick={(e) => this.setActivePage(3)}
                                className={"header-link row" + (this.state.active_page === 3 && "active")}>
                                <img className="header-link-img" src={user} alt=""/>
                                پروفایل
                            </Link>
                            <Link
                                to={{pathname: `/profile/`}}
                                onClick={(e) => this.setActivePage(3)}
                                className={"header-link-phone order-1" + (this.state.active_page === 3 && "active")}>
                                <img className="header-link-img" src={user} alt=""/>
                            </Link>
                            <Link
                                to={{
                                    pathname: `/favorite/`
                                }}
                                onClick={(e) => this.setActivePage(1)}
                                className={"header-link row " + (this.state.active_page === 1 && "active")}>
                                <img className="header-link-img" src={favorite} alt=""/>
                                علاقه مندی ها
                            </Link>
                            <Link
                                to={{
                                    pathname: `/favorite/`
                                }}
                                onClick={(e) => this.setActivePage(1)}
                                className={"header-link-phone order-2 " + (this.state.active_page === 1 && "active")}>
                                <img className="header-link-img" src={favorite} alt=""/>
                            </Link>
                            <Link
                                to={{
                                    pathname: `/playlist/`
                                }}
                                onClick={(e) => this.setActivePage(2)}
                                className={"header-link row " + (this.state.active_page === 2 && "active")}>
                                <img className="header-link-img" src={playlist} alt=""/>
                                پلی‌لیست‌ها
                            </Link>
                            <Link
                                to={{
                                    pathname: `/playlist/`
                                }}
                                onClick={(e) => this.setActivePage(2)}
                                className={"header-link-phone order-3 mr-auto " + (this.state.active_page === 2 && "active")}>
                                <img className="header-link-img" src={playlist} alt=""/>
                            </Link>
                            <input className="search-input order-sm-4 order-6" type="text" placeholder="جستجو"
                                   aria-label="Search"/>
                            <Link
                                className="shefa-logo order-sm-6 order-5 d-flex align-items-center justify-content-end"
                                to={{
                                    pathname: `/`
                                }}>
                                بیان معارف الهی، انسانی، اجتماعی
                                <img className="w-100 p-1" src={logo} alt=""/>
                            </Link>
                        </nav>
                    </div>
                </header>
            </>
        );
    }
}

export default Header;
